const projects = [
  {
    project: "Guideline",
    image: "guidelineGrid.jpg",
    title: "Guideline Mobile App",
    skills: "Producer",
  },
  {
    project: "andjustlikethat",
    image: "1O2A0801.jpg",
    title: "And Just Like That x Saks Fifth Avenue",
    skills: "Lead Producer",
  },
  {
    project: "CashApp",
    image: "CashAppBankingHero.jpg",
    title: "Cash App Website",
    skills: "Producer",
  },
  {
    project: "MaskedContexts",
    image: "MaskedContextgrid.jpg",
    title: "Masked Contexts",
    skills: "Design | Code",
  },
  {
    project: "Versace",
    image: "versace.jpg",
    title: "Versace Shanghai Popup",
    skills: "Producer | Design | Creative Technology",
  },
  {
    project: "Lensfest",
    image: "lensfest.jpg",
    title: "Snapchat Lens Fest",
    skills: "Producer",
  },
  {
    project: "LVNBA",
    image: "lv.jpg",
    title: "Louis Vuitton x NBA",
    skills: "Producer | Creative Technology",
  },
  {
    project: "MGMCotai",
    image: "mgm_hero.jpg",
    title: "MGM Cotai Spectacle",
    skills: "Producer",
  },
  {
    project: "Runway360",
    image: "runwayHero.jpg",
    title: "CFDA Runway 360",
    skills: "Producer",
  },
  {
    project: "FakeMirror",
    image: "falsemirror-grid.jpg",
    title: "Fake Mirror",
    skills: "Design | Code",
  },
  {
    project: "OBE",
    image: "OBE_hero-min.jpg",
    title: "Oldcastle Building Envelope AIA Booth",
    skills: "Producer | Event Production",
  },
  {
    project: "MOF",
    image: "MOF_hero.jpg",
    title: "Museum of Feelings",
    skills: "Producer",
  },
  // {
  //   project: "Nobu",
  //   image: "nobu_hero.jpg",
  //   title: "Nobu Downtown Digital Pond",
  //   skills: "Producer",
  // }
  // {
  //   project: "MFADTSite",
  //   image: "hindsightHero.png",
  //   title: "Hindsight Thesis Website",
  //   skills: "Design | Code | Producer",
  // },
  // {
  //   project: "ParticleSystemLetters",
  //   image: "OFmidterm.png",
  //   title: "Particle System Alphabet",
  //   skills: "Design | Code",
  // },
    // {
  //   project: "CollectiveUnbelonging",
  //   image: "ms1Final_img-min.png",
  //   title: "Collective Unbelonging",
  //   skills: "Design | Code",
  // },
  // {
  //   project: "TheBoat",
  //   image: "theBoatImg.png",
  //   title: "The Boat",
  //   skills: "Design | Code",
  // },
];

export default projects;
